// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guide-kWYXGZ{width:380px}.guide-text-sTUcC1{margin-bottom:8px;font-size:16px;font-weight:600;line-height:22px}.guide-image-naSMmT{width:380px;margin:0 0 10px;padding:0}.guide-video-FvTMRA{border-radius:8px;width:380px;margin-bottom:8px;overflow:hidden}.guide-button-bpDCaN{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"guide": `guide-kWYXGZ`,
	"guide-text": `guide-text-sTUcC1`,
	"guideText": `guide-text-sTUcC1`,
	"guide-image": `guide-image-naSMmT`,
	"guideImage": `guide-image-naSMmT`,
	"guide-video": `guide-video-FvTMRA`,
	"guideVideo": `guide-video-FvTMRA`,
	"guide-button": `guide-button-bpDCaN`,
	"guideButton": `guide-button-bpDCaN`
};
export default ___CSS_LOADER_EXPORT___;
